// extracted by css-extract-rspack-plugin
export default {"photoWrapper":"InR9xPIJU6QAinlG","photo":"uPHzy4Xy6r8upq1J","unloadImg":"qBhjhmdGqqoHhxVw"};